// extracted by mini-css-extract-plugin
export default {"container":"bp-z","heading":"cp-z","text":"dp-z","info":"ep-z","link":"fp-z","fullMaxWidth":"gp-z"};